import {TaskModelRawDTO} from 'shared/models/task/task';

export function nullsFirstOSKSort(a: TaskModelRawDTO, b: TaskModelRawDTO) {
  if (a.outline_sort_key === b.outline_sort_key) {
    return 0;
  }
  if (!a.outline_sort_key) {
    return -1;
  } else if (!b.outline_sort_key) {
    return 1;
  } else {
    return a.outline_sort_key.localeCompare(b.outline_sort_key);
  }
}
